module.exports = __webpack_public_path__ + "media/dorm_2400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/dorm_2400.jpg
// module id = 25
// module chunks = 0